var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"fb",class:_vm.lang,attrs:{"target":" _blank","href":_vm.comment}},[_c('img',{attrs:{"id":"gshare_fb","alt":"facebook_share","target":" _blank","width":"28","height":"28","src":"images/btn_share_fb.png"}})])}
var staticRenderFns = []

export { render, staticRenderFns }